import axios from "../utils/axios";

export const adminLoginApi = (data) =>
  axios.post(
    "/api/admin/login",
    data
  );